import React from 'react';
import { cssColorValue, cssSpacing, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { Headline, Numbers, MediaWithCaption, DescriptionsWithCTA, } from './components';
import styled from 'styled-components';
import { Grid } from '../../ui';
const GridWrapper = styled(Grid) `
  box-sizing: border-box;
  padding-top: ${cssSpacing('looser-3')};
  padding-bottom: ${cssSpacing('looser-6')};
`;
const BorderLine = styled.div `
  height: 1px;
  background-color: ${cssColorValue('textBase')};
  opacity: 0.5;
  width: 100%;
  grid-column: -1 / 1;
`;
const BorderInGrid = () => {
    return (React.createElement(Grid, null,
        React.createElement(BorderLine, null)));
};
export const DataHighlightModule = React.forwardRef(({ number, totalNumber, headline, media, mediaCaptionHeadline, mediaCaptionDescription, primaryDescriptionEyebrow, primaryDescription, secondaryDescriptionEyebrow, secondaryDescription, ctaUrl, ctaText, ctaNewTab, colors, }, ref) => {
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement(BorderInGrid, null),
            React.createElement(GridWrapper, { ref: ref },
                React.createElement(Headline, { noNumbers: !number }, headline),
                number && totalNumber && (React.createElement(Numbers, { number: number, totalNumber: totalNumber })),
                React.createElement(MediaWithCaption, { media: media, captionHeadline: mediaCaptionHeadline, captionDescription: mediaCaptionDescription }),
                React.createElement(DescriptionsWithCTA, { primaryDescription: primaryDescription, primaryDescriptionEyebrow: primaryDescriptionEyebrow, secondaryDescription: secondaryDescription, secondaryDescriptionEyebrow: secondaryDescriptionEyebrow, ctaNewTab: ctaNewTab, ctaText: ctaText, ctaUrl: ctaUrl })))));
});
